import React from 'react';
import { useState } from 'react';
import PropTypes from 'prop-types';
import { hasLayers, hasSubCategories } from '../../../../lib/layers.js';
import ChevronDown from '../../../../assets/svg/Feather/ChevronDown';
import ChevronRight from '../../../../assets/svg/Feather/ChevronRight';
import LayerCategoryDetail from '../LayerCategoryDetail';
import styles from './LayerCategoryListItem.module.scss';

export default function LayerCategoryListItem(props) {
  const [categoryIsOpen, setCategoryIsOpen] = useState(props.categoryIsOpen)

  const isCategoryActive = (category) => {
    if (hasSubCategories(category)) {
      let subCatActiveList = category.subCategories.map((subCat) => {
        if (hasLayers(subCat)) {
          let active = false;
          subCat.layers.forEach((layer) => {
            if (layer.control.enabled == 1) {
              active = true;
            }
          });
          return active;
        } else {
          return false;
        }
      });

      return subCatActiveList.reduce((acc, cur) => acc || cur, false);
    }

    if (hasLayers(category)) {
      return category.layers.reduce(
        (acc, layer) => acc || layer.control.enabled == 1,
        false
      );
    }

    return false;
  };

  const showCategoryDetails = (e) => {
    if (props.category.isPublished) {
      setCategoryIsOpen(!categoryIsOpen)
      const isSpecialEventLayer = ['tac', 'total archery challenge'].includes(props.stateName.toLowerCase())
      if (!isSpecialEventLayer) {
        props.dispatch({
          type: 'map/geocodeMapCenter',
          callback: (mapCenterInfo) => {
            if (
              mapCenterInfo &&
              mapCenterInfo.address &&
              mapCenterInfo.address.PlaceName &&
              mapCenterInfo.address.PlaceName.trim().toLowerCase() !==
              props.stateName.trim().toLowerCase()
            ) {
              props.dispatch({
                type: 'map/goToState',
                payload: props.stateName,
              })
            }
          },
        })
      }
      props.dispatch({
        type: 'layers/setSelectedLayerCategory',
        payload: {
          stateName: props.stateName,
          categoryName: props.categoryName,
        },
      })
    }
  }

  const isActive = isCategoryActive(props.category);
  return (
    <div className={`${styles.categorySection} ${categoryIsOpen && styles.categoryIsOpen}`}>
      <div className={styles.categorySectionHeader}>
        <div className={`${styles.categoryListItem} ${!props.category.isPublished && styles.disabled} ${categoryIsOpen && styles.categoryIsOpen}`} onClick={showCategoryDetails}>
          <div className={styles.categoryName}>
            <p>{props.categoryName}</p>
            {props.category.description && (<p className={styles.categoryDescription}>{props.category.description}</p>)}
          </div>
          <div className={`${styles.categoryIndicator} ${isActive ? styles.categoryActive : styles.categoryInactive}`} />
          {categoryIsOpen ? <i className={styles.categoryIsOpen}><ChevronDown color='#8e8e92' /></i> : <i className={styles.categoryIsClosed}><ChevronRight color='#8e8e92' /></i>}
        </div>
      </div>
      {categoryIsOpen && (
        <div className={styles.categoryList}>
          <LayerCategoryDetail category={props.category} stateName={props.stateName} dispatch={props.dispatch} userProfile={props.userProfile} />
        </div>
      )}
    </div>
  )
}

LayerCategoryListItem.propTypes = {
  category: PropTypes.object,
  categoryIsOpen: PropTypes.bool,
  categoryName: PropTypes.string,
  dispatch: PropTypes.func,
  stateName: PropTypes.string,
  userProfile: PropTypes.object
};

LayerCategoryListItem